(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["end-of-line-size-filter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brut-eol-size-groups')) {
    customElements.define(
      'brut-eol-size-groups',
      class extends HTMLElement {
        connectedCallback() {
          this.frame = requestAnimationFrame(() => this.init());
        }

        init() {
          this.controller?.abort();
          this.resizeObserver?.disconnect();

          this.controller = new AbortController();

          const options = {
            signal: this.controller.signal
          };

          this.dialog = this.querySelector('dialog');
          this.trigger = this.querySelector('[data-eol-open]');

          const closeButton = this.querySelector('[data-eol-close]');
          const mobileBar = this.querySelector('.eol-menu__bar');

          if (!this.dialog || !this.trigger || !closeButton) return;

          this.trigger.addEventListener(
            'click',
            () => this.openMenu(),
            options
          );

          closeButton.addEventListener(
            'click',
            () => this.closeMenu(),
            options
          );

          this.dialog.addEventListener(
            'click',
            (event) => {
              if (event.target !== this.dialog) return;

              const rect = this.dialog.getBoundingClientRect();

              if (
                event.clientX < rect.left ||
                event.clientX > rect.right ||
                event.clientY < rect.top ||
                event.clientY > rect.bottom
              ) {
                this.closeMenu();
              }
            },
            options
          );

          this.dialog.addEventListener(
            'close',
            () => {
              this.restoreScroll();
              this.trigger.setAttribute('aria-expanded', 'false');

              if (
                this.isConnected &&
                getComputedStyle(mobileBar).display !== 'none'
              ) {
                this.trigger.focus({ preventScroll: true });
              }
            },
            options
          );

          const closeOnDesktop = () => {
            if (
              this.dialog.open &&
              getComputedStyle(mobileBar).display === 'none'
            ) {
              this.closeMenu();
            }
          };

          window.addEventListener(
            'resize',
            closeOnDesktop,
            options
          );

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(closeOnDesktop);
            this.resizeObserver.observe(this);
          }

          const prepareLink = (event) => {
            const link = event.target.closest?.('a[data-eol-link]');

            if (link && this.contains(link)) {
              this.updateLink(link);
            }
          };

          this.addEventListener(
            'pointerdown',
            prepareLink,
            options
          );

          this.addEventListener(
            'focusin',
            prepareLink,
            options
          );

          this.addEventListener(
            'click',
            (event) => {
              const link = event.target.closest?.('a[data-eol-link]');

              if (!link || !this.contains(link)) return;

              this.updateLink(link);

              if (
                event.button !== 0 ||
                event.metaKey ||
                event.ctrlKey ||
                event.shiftKey ||
                event.altKey
              ) {
                return;
              }

              event.preventDefault();
              event.stopPropagation();

              this.closeMenu();

              window.location.assign(link.href);
            },
            options
          );

          window.addEventListener(
            'pagehide',
            () => this.closeMenu(),
            options
          );
        }

        openMenu() {
          if (this.dialog.open) return;

          this.dialog.showModal();

          this.previousOverflow = [
            document.documentElement,
            document.body
          ].map((element) => ({
            element,
            value: element.style.getPropertyValue('overflow'),
            priority: element.style.getPropertyPriority('overflow')
          }));

          this.previousOverflow.forEach(({ element }) => {
            element.style.setProperty(
              'overflow',
              'hidden',
              'important'
            );
          });

          this.trigger.setAttribute('aria-expanded', 'true');
        }

        closeMenu() {
          if (this.dialog?.open) {
            this.dialog.close();
          }

          this.restoreScroll();

          this.trigger?.setAttribute('aria-expanded', 'false');
        }

        restoreScroll() {
          if (!this.previousOverflow) return;

          this.previousOverflow.forEach(({
            element,
            value,
            priority
          }) => {
            if (value) {
              element.style.setProperty(
                'overflow',
                value,
                priority
              );
            } else {
              element.style.removeProperty('overflow');
            }
          });

          this.previousOverflow = null;
        }

        updateLink(link) {
          const param = this.dataset.filterParam;

          if (!param) return;

          const current = new URL(window.location.href);

          const selected = new Set(
            current.searchParams
              .getAll(param)
              .flatMap((value) => value.split(','))
              .filter(Boolean)
          );

          if (link.hasAttribute('data-eol-clear')) {
            selected.clear();
          } else {
            let values;

            try {
              values = JSON.parse(link.dataset.eolValues || '[]')
                .flatMap((value) => value.split(','))
                .filter(Boolean);
            } catch (error) {
              return;
            }

            if (!values.length) return;

            // Un groupe actif se deselectionne dans son ensemble.

            const remove = values.some((value) =>
              selected.has(value)
            );

            values.forEach((value) => {
              if (remove) {
                selected.delete(value);
              } else {
                selected.add(value);
              }
            });
          }

          current.searchParams.delete(param);

          selected.forEach((value) => {
            current.searchParams.append(param, value);
          });

          current.searchParams.set(
            'filter.v.availability',
            '1'
          );

          [...current.searchParams.keys()].forEach((key) => {
            if (
              key === 'page' ||
              key.startsWith('page_') ||
              key === 'section_id' ||
              key === 'sections'
            ) {
              current.searchParams.delete(key);
            }
          });

          current.hash = '';

          link.href = current.href;
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);

          this.controller?.abort();
          this.resizeObserver?.disconnect();

          this.closeMenu();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  } catch(e) { console.error(e); }
})();
})();
